import React, {useState, useContext, useEffect} from 'react';
import { UserRegistrationContext } from "./ShareStates";
import {
    postUserRegisterCreateAccount,
    getMutationResult
} from "../../commonFunctions/GraphqlFunctions";

const AccountForm = () => {
    const {
        serialNumber1,
        // serialNumber2,
        zipcode,
        region,
        firstName,
        lastName,
        userName,
        userPassword,
        previousForm,
        updateDisplayForm,
        updateFirstName,
        updateLastName,
        updateUserName,
        updateUserPassword
    } = useContext(UserRegistrationContext);
    const [firstNameValue, setFirstNameValue] = useState("");
    const [lastNameValue, setLastNameValue] = useState("");
    const [userNameValue, setUserNameValue] = useState("");
    const [userPasswordValue, setUserPasswordValue] = useState("");
    const [userPasswordShowChecked, setUserPasswordShowChecked] = useState("");
    const [userPasswordInputType, setUserPasswordInputType] = useState("password");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [userNameError, setUserNameError] = useState("");
    const [userPasswordError, setUserPasswordError] = useState("");
    const [mountReadOnce, setMountReadOnce] = useState("none");
    const [displayError, setDisplayError] = useState("none");

    useEffect(() => {
        if (mountReadOnce === "none") {
            setFirstNameValue(firstName);
            setLastNameValue(lastName);
            setUserNameValue(userName);
            setUserPasswordValue(userPassword);
            setMountReadOnce("visited");
        }
    }, [
        mountReadOnce,
        firstName,
        lastName,
        userName,
        userPassword,
        firstNameValue,
        lastNameValue,
        userNameValue,
        userPasswordValue,
        setMountReadOnce,
        setFirstNameValue,
        setLastNameValue,
        setUserNameValue,
        setUserPasswordValue
    ]);

    const backButtonAction = (event) => {
        event.preventDefault();
        updateFirstName(firstNameValue);
        updateLastName(lastNameValue);
        updateUserName(userNameValue);
        updateUserPassword(userPasswordValue);
        if (region.value === "USA" || region.value === undefined) {
            updateDisplayForm("zipForm");
        }
        else {
            updateDisplayForm("regionForm");
        }
    }

    const inputChange = (event) => {
        event.preventDefault();
        if (event.target.id === "first_name") {
            setFirstNameValue(event.target.value);
            setFirstNameError("");
        }
        if (event.target.id === "last_name") {
            setLastNameValue(event.target.value);
            setLastNameError("");
        }
        if (event.target.id === "user_name") {
            setUserNameValue(event.target.value);
            setUserNameError("");
        }
        if (event.target.id === "user_password") {
            setUserPasswordValue(event.target.value);
            setUserPasswordError("");
        }
        if (event.target.id === "show") {
            if (userPasswordShowChecked === "") {
                setUserPasswordShowChecked("checked");
                setUserPasswordInputType("text");
            }
            else {
                setUserPasswordShowChecked("");
                setUserPasswordInputType("password");
            }
        }
    }

    const createAccountAction = async (event) => {
        event.preventDefault();
        if (firstNameValue.trim() === "") {
            setFirstNameError("First Name is Required");
        }
        if (lastNameValue.trim() === "") {
            setLastNameError("Last Name is Required");
        }
        if (userNameValue.trim() === "") {
            setUserNameError("User Name is Required");
        }
        if (userPasswordValue.trim() === "") {
            setUserPasswordError("Password is Required");
        }
        if (firstNameValue.trim() !== "" && lastNameValue.trim() !== "" && userNameValue.trim() !== "" && userPasswordValue.trim() !== "") {
            let postUserRegisterCreateAccountResult;
            if (previousForm === 'zipForm') {
                postUserRegisterCreateAccountResult = await getMutationResult(
                    postUserRegisterCreateAccount(previousForm),
                    {
                        "serialNumber1": serialNumber1,
                        // "serialNumber2": serialNumber2,
                        "zipcode": zipcode,
                        "firstName": firstNameValue,
                        "lastName": lastNameValue,
                        "userName": userNameValue,
                        "userPassword": userPasswordValue
                    }
                );
            }
            if (previousForm === 'regionForm') {
                 postUserRegisterCreateAccountResult = await getMutationResult(
                    postUserRegisterCreateAccount(previousForm),
                    {
                        "serialNumber1": serialNumber1,
                        // "serialNumber2": serialNumber2,
                        "region": region.value,
                        "firstName": firstNameValue,
                        "lastName": lastNameValue,
                        "userName": userNameValue,
                        "userPassword": userPasswordValue
                    }
                );
            }

            console.log(postUserRegisterCreateAccountResult);
            if (postUserRegisterCreateAccountResult !== undefined) {
                if (postUserRegisterCreateAccountResult.data['supportSiteUserRegisterCreateAccount']['message'] !== undefined) {
                    let messageOutput = postUserRegisterCreateAccountResult.data['supportSiteUserRegisterCreateAccount']['message'];
                    if (messageOutput === "invalid email address format") {
                        setUserNameError("Invalid Email Address Format")
                    }
                    else if (messageOutput === "user name already taken") {
                        setUserNameError("Username already taken")
                    }
                    else if (messageOutput === "password not meet complexity") {
                        setUserPasswordError("You password must be at least 8 characters long and contain a letter, a uppercase letter, a number and a special character")
                    }
                    else {
                        console.log(messageOutput)
                        setDisplayError("block");
                    }
                }
                else{
                    updateDisplayForm("registrationCompletedForm")
                }
            }
            else {
                setDisplayError("block");
            }
        }
    }

    return (
        <React.Fragment>
            <fieldset name={"accountStep"} style={{display: "block"}}>
                <h1>Tell us about about your account</h1>
                <div className={"errorNotice"} style={{display: displayError}}>
                    There is error contacting the backend server, please contact administrator.
                </div>
                <input type={"text"} name={"first_name"} id={"first_name"} className={"required noTopMargin"} placeholder={"Enter first name"} value={firstNameValue} onChange={inputChange}></input>
                <span id={"error_first_name"} className={"error"}>{firstNameError}</span>
                <input type={"text"} name={"last_name"} id={"last_name"} className={"required"} placeholder={"Enter last name"} value={lastNameValue} onChange={inputChange}></input>
                <span id={"error_last_name"} className={"error"}>{lastNameError}</span>
                <input type={"text"} name={"user_name"} id={"user_name"} className={"required"} placeholder={"Enter an email address"} value={userNameValue} onChange={inputChange}></input>
                <span id={"error_user_name"} className={"error"}>{userNameError}</span>
                <div className={"groupedFormElements"}>
                    <input type={userPasswordInputType} name={"user_password"} id={"user_password"} className={"required"} placeholder={"Enter a password"} value={userPasswordValue} onChange={inputChange}></input>
                    <div className={"showPW"}>
                        <input type={"checkbox"} name={"show"} id={"show"} value={"showText"} className={userPasswordShowChecked} onClick={inputChange}></input>
                        <label htmlFor={"show"}>Show</label>
                    </div>
                    <span id={"error_user_password"} className={"error"}>{userPasswordError}</span>
                </div>
                <div style={{width: '100%'}}>
                    <div style={{width: '50%', float: "left", paddingRight: '10px'}}>
                        <button type={"button"} className={"backButton btn"} title={"Next"} onClick={backButtonAction}>
                            <span>Back</span>
                        </button>
                    </div>
                    <div style={{width: '50%', float: "right", paddingLeft: '10px'}}>
                        <button type={"submit"} id={"submit"} className={"formSubmit btn"} title={"Submit"} onClick={createAccountAction}>
                            <span>Create Account</span>
                        </button>
                    </div>
                    <div style={{clear: "both"}}></div>
                </div>
            </fieldset>
        </React.Fragment>
    )
}

export default AccountForm;
